/**
 * Whether the alert stack is expanded. Shared by the header bell (which toggles it) and the
 * host (which renders it); a new alert re-opens a collapsed stack — that is the point of it.
 */
type Listener = () => void;

const listeners = new Set<Listener>();
let open = true;
/** Opened from the bell (a user choice), as opposed to re-opened by a new alert. */
let explicit = false;

const emit = () => listeners.forEach((l) => l());

export const alertUi = {
	subscribe: (listener: Listener) => {
		listeners.add(listener);
		return () => {
			listeners.delete(listener);
		};
	},
	isOpen: () => open,
	isExplicit: () => explicit,
	setOpen: (next: boolean) => {
		if (open === next && (next || !explicit)) return;
		open = next;
		if (!next) explicit = false;
		emit();
	},
	/** The bell, opening: shows the stack everywhere, the Cancelled units page included. */
	openFromBell: () => {
		if (open && explicit) return;
		open = true;
		explicit = true;
		emit();
	},
	/** Leaving or entering a page forgets a bell-opened state. */
	clearExplicit: () => {
		if (!explicit) return;
		explicit = false;
		emit();
	},
	reset: () => {
		open = true;
		explicit = false;
		listeners.clear();
	},
};
